export default "__VITE_ASSET__C531ZMYc__"